<template>
  <app-layout style="padding-top: 0px">
    <div slot="conteudo"></div>
  </app-layout>
</template>

<script>
export default {
  data() {
    return {};
  },
};
</script>

<style>
</style>